export default __webpack_public_path__ + "static/media/image.11366218.svg";